import React from 'react'
import { Modal, ModalInjectedProps, Skeleton } from '@sketch/components'

import {
  Header,
  IconWrapper,
  HeaderContent,
  Section,
  InfoTable,
  SkeletonIcon,
  SkeletonTitle,
  SkeletonSectionTitle,
} from './IntegrationSettingsModal.styles'

interface IntegrationSettingsModalSkeletonProps extends ModalInjectedProps {}

export const IntegrationSettingsModalSkeleton: React.FC<
  IntegrationSettingsModalSkeletonProps
> = ({ hideModal }) => {
  return (
    <Modal onCancel={hideModal}>
      <Modal.Body>
        <Header>
          <IconWrapper $isSkeleton={true}>
            <SkeletonIcon width="64px" height="64px" />
          </IconWrapper>
          <HeaderContent>
            <SkeletonTitle width="180px" height="24px" />
            <Skeleton width="80px" height="16px" />
          </HeaderContent>
        </Header>

        <Section>
          <SkeletonSectionTitle width="100px" height="16px" />
          <Skeleton width="100%" height="60px" />
        </Section>

        <Section>
          <SkeletonSectionTitle width="100px" height="16px" />
          <InfoTable>
            <tbody>
              <tr>
                <td>
                  <Skeleton width="80px" height="16px" />
                </td>
                <td>
                  <Skeleton width="150px" height="16px" />
                </td>
              </tr>
              <tr>
                <td>
                  <Skeleton width="80px" height="16px" />
                </td>
                <td>
                  <Skeleton width="120px" height="16px" />
                </td>
              </tr>
              <tr>
                <td>
                  <Skeleton width="80px" height="16px" />
                </td>
                <td>
                  <Skeleton width="140px" height="16px" />
                </td>
              </tr>
            </tbody>
          </InfoTable>
        </Section>

        <Section>
          <SkeletonSectionTitle width="80px" height="16px" />
          <Skeleton width="100%" height="40px" />
        </Section>
      </Modal.Body>
      <Modal.Footer leftContent={<Skeleton width="60px" height="32px" />}>
        <Skeleton width="60px" height="32px" />
        <Skeleton width="60px" height="32px" />
      </Modal.Footer>
    </Modal>
  )
}
